import React from "react";
import { Button, Form, FormGroup, FormInput } from "shards-react";
import withLoading from "../../../hocs/withLoading/withLoading";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";

const AuthForm = props => {
    const { configFirstInput, configSecondInput, configButton } = props;
    const { formSubmit, onchange } = props.actions;
    return (
        <>
            <Form
                onSubmit={e => formSubmit(e)}
                autoComplete="off"
                style={{ marginBottom: "10px" }}
            >
                <FormGroup>
                    <label htmlFor={configFirstInput.name}>
                        {configFirstInput.label}
                    </label>
                    <FormInput
                        required
                        autoComplete={"off"}
                        type={configFirstInput.type}
                        placeholder={configFirstInput.label}
                        name={configFirstInput.name}
                        value={configFirstInput.value}
                        valid={configFirstInput.valid}
                        onChange={e => onchange(e)}
                    />
                </FormGroup>
                <FormGroup>
                    <label htmlFor={configSecondInput.name}>
                        {configSecondInput.label}
                    </label>
                    <FormInput
                        required
                        autoComplete={"off"}
                        type={configSecondInput.type}
                        placeholder={configSecondInput.label}
                        name={configSecondInput.name}
                        value={configSecondInput.value}
                        valid={configSecondInput.valid}
                        onChange={e => onchange(e)}
                    />
                </FormGroup>
                <Button
                    size={"sm"}
                    pill
                    style={{ marginBottom: 30 }}
                    className={"cypress--confirm-button"}
                    block
                    disabled={configButton.disabled}
                    type="submit"
                >
                    {configButton.label}
                </Button>
                <Link
                    to={{
                        pathname: "/accounts/password/reset/"
                    }}
                >
                    Esqueceu sua senha?
                </Link>
            </Form>
        </>
    );
};

AuthForm.propTypes = {
    actions: PropTypes.object,
    showIcon: PropTypes.bool,
    configSecondtInput: PropTypes.object,
    configFirstInput: PropTypes.object
};

const WrappedComponent = withLoading(AuthForm);

export default WrappedComponent;
